var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoSupervisores(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.788,
    height: 66.788,
    viewBox: "0 0 66.788 66.788",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_179",
    x: 0,
    y: 0,
    width: 66.788,
    height: 66.788,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12790",
    "data-name": "Trazado 12790",
    d: "M2.825,0V16.8a27.135,27.135,0,1,0,47.484-2.055V0Z",
    transform: "translate(0)",
    fill: "#b7006d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ilustraci\\xF3n_supervisores",
    "data-name": "ilustraci\\xF3n supervisores",
    transform: "translate(-84.898 -285.147)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 84.9, 285.15)",
    filter: "url(#Elipse_179)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_179-2",
    "data-name": "Elipse 179",
    cx: 27.394,
    cy: 27.394,
    r: 27.394,
    transform: "translate(6 3)",
    fill: "#ffdede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19768",
    "data-name": "Grupo 19768",
    transform: "translate(91.077 287.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19767",
    "data-name": "Grupo 19767",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22363",
    "data-name": "Rect\\xE1ngulo 22363",
    width: 10.608,
    height: 12.746,
    transform: "translate(35.771 7.982)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12742",
    "data-name": "Trazado 12742",
    d: "M153.629,13.467a5.373,5.373,0,1,0,7.451-1.66,5.4,5.4,0,0,0-7.451,1.66",
    transform: "translate(-117.061 -8.399)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12743",
    "data-name": "Trazado 12743",
    d: "M155.7,15.693a4.867,4.867,0,1,0,6.75-1.5,4.89,4.89,0,0,0-6.75,1.5",
    transform: "translate(-118.712 -10.286)",
    fill: "#fdbfb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12744",
    "data-name": "Trazado 12744",
    d: "M171.893,56.033l-.026,4.635c-.007.985-.618.858-1.588.843-.828-.013-1.6-.162-1.689-.985l.254-5.883Z",
    transform: "translate(-129.19 -41.873)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12745",
    "data-name": "Trazado 12745",
    d: "M168.844,60.6l3.321-1.844L168.993,58Z",
    transform: "translate(-129.385 -44.448)",
    fill: "#4a280d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12746",
    "data-name": "Trazado 12746",
    d: "M155.887,19.437a4.647,4.647,0,1,0,9.287,0,4.646,4.646,0,0,0-9.287,0",
    transform: "translate(-119.456 -11.455)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12747",
    "data-name": "Trazado 12747",
    d: "M152.459,40.314a1.269,1.269,0,1,0,1.269-1.269,1.269,1.269,0,0,0-1.269,1.269",
    transform: "translate(-116.829 -29.92)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12748",
    "data-name": "Trazado 12748",
    d: "M191.358,40.314a1.269,1.269,0,1,1-1.269-1.269,1.269,1.269,0,0,1,1.269,1.269",
    transform: "translate(-144.693 -29.92)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12749",
    "data-name": "Trazado 12749",
    d: "M159.329,21.528a17.321,17.321,0,0,0,.463,3.95,3.447,3.447,0,0,0,1.764,2.164l.164.1a3.17,3.17,0,0,0,3.151.034,3.463,3.463,0,0,0,1.869-2.31,25.314,25.314,0,0,0,.424-3.936,3.543,3.543,0,0,0-3.862-3.95,3.711,3.711,0,0,0-3.974,3.95",
    transform: "translate(-122.091 -13.469)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12750",
    "data-name": "Trazado 12750",
    d: "M164.822,17.1s1.011,4.5,6.947,4.095c0,0-.234-4.442-3.111-4.813,0,0-2.815-.4-3.836.718",
    transform: "translate(-126.303 -12.498)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12751",
    "data-name": "Trazado 12751",
    d: "M160.948,17.575a7.033,7.033,0,0,1-2.74,4.887l-.365-1.478a3.052,3.052,0,0,1,3.105-3.409",
    transform: "translate(-120.944 -13.468)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12752",
    "data-name": "Trazado 12752",
    d: "M189.368,34.152l.688,1.928.3-1.928Z",
    transform: "translate(-145.113 -26.171)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12753",
    "data-name": "Trazado 12753",
    d: "M159.691,34.152l-.713,1.766-.274-1.766Z",
    transform: "translate(-121.615 -26.171)",
    fill: "#1f120c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12754",
    "data-name": "Trazado 12754",
    d: "M127.936,129.721s5.637,6.363,5.52,13.106-1.283,34.866-1.283,34.866h-5.125l-1.864-37.934-.677-.041-9.016,37.992-4.783-.506,5.716-36.538s1.723-6.492,4.886-10.4Z",
    transform: "translate(-84.836 -99.405)",
    fill: "#228f99"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_100",
    "data-name": "L\\xEDnea 100",
    y1: 0.54,
    x2: 3.097,
    transform: "translate(38.835 40.01)",
    fill: "none",
    stroke: "#09090b",
    strokeWidth: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12755",
    "data-name": "Trazado 12755",
    d: "M192.77,86.719l3.009,11.372a1.526,1.526,0,0,1-1.222,1.939,1.789,1.789,0,0,1-1.838-.986l-3.875-10.968a2.079,2.079,0,1,1,3.925-1.356",
    transform: "translate(-144.599 -65.31)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12756",
    "data-name": "Trazado 12756",
    d: "M208.868,136.6l1.286,11.679-2.282-.1-2.184-11.165a1.844,1.844,0,0,1,1.352-2.1,1.79,1.79,0,0,1,1.829,1.69",
    transform: "translate(-157.6 -103.371)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12757",
    "data-name": "Trazado 12757",
    d: "M215.555,188.648s3.185,4.017-.051,6.15a.541.541,0,0,1-.682-.076l-.024-.025a.55.55,0,0,1-.026-.74,2,2,0,0,0-.143-2.858s-.531.178-.348,1.259a.442.442,0,0,1-.443.523.457.457,0,0,1-.419-.313c-.238-.7-.683-2.461.372-3.5Z",
    transform: "translate(-163.312 -144.561)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12758",
    "data-name": "Trazado 12758",
    d: "M101.876,75.687,86.261,90.151l-1.83-2.222L98.953,73.56a2.222,2.222,0,0,1,2.885-.394l-.092-.084a1.791,1.791,0,0,1,.13,2.606",
    transform: "translate(-64.699 -55.782)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12759",
    "data-name": "Trazado 12759",
    d: "M158.986,72.993l4.258,2.921-3.437,9.95-6.626.544L152.3,77.28l.345-4.791Z",
    transform: "translate(-116.708 -55.548)",
    fill: "#af5e4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12760",
    "data-name": "Trazado 12760",
    d: "M153.737,73.819s-.851,2.641-3.368,2.068-2.613-3.656-2.613-3.656l-3.268-.251-1.479,19.311,3.463.038,10.131-.038V75.123Z",
    transform: "translate(-109.588 -55.158)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12761",
    "data-name": "Trazado 12761",
    d: "M18.495,81.128H41.642a1.919,1.919,0,0,0,1.919-1.919V45.48a1.919,1.919,0,0,0-1.919-1.919H18.495a1.919,1.919,0,0,0-1.919,1.919v33.73a1.919,1.919,0,0,0,1.919,1.919",
    transform: "translate(-12.702 -33.381)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12762",
    "data-name": "Trazado 12762",
    d: "M21.957,82.773H43.632a1.823,1.823,0,0,0,1.823-1.823V48.455a1.823,1.823,0,0,0-1.823-1.823H21.957a1.823,1.823,0,0,0-1.823,1.823V80.95a1.823,1.823,0,0,0,1.823,1.823",
    transform: "translate(-15.429 -35.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12763",
    "data-name": "Trazado 12763",
    d: "M92.471,75.619h5.375a.578.578,0,0,0,.578-.578V67.9a.578.578,0,0,0-.578-.577H92.471a.578.578,0,0,0-.578.577v7.144a.578.578,0,0,0,.578.578",
    transform: "translate(-70.418 -51.587)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12764",
    "data-name": "Trazado 12764",
    d: "M94.457,87.556a.188.188,0,0,0,.188.188H99.61a.188.188,0,0,0,.188-.188.149.149,0,0,0,0-.02,2.677,2.677,0,0,0-5.339,0,.148.148,0,0,0,0,.02",
    transform: "translate(-72.382 -65.186)",
    fill: "#17565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12765",
    "data-name": "Trazado 12765",
    d: "M101.062,74.762a1.126,1.126,0,1,0,1.121-1.132,1.126,1.126,0,0,0-1.121,1.132",
    transform: "translate(-77.444 -56.423)",
    fill: "#17565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12766",
    "data-name": "Trazado 12766",
    d: "M92.471,116.193h5.375a.578.578,0,0,0,.578-.578v-7.144a.578.578,0,0,0-.578-.578H92.471a.578.578,0,0,0-.578.577v7.144a.578.578,0,0,0,.578.578",
    transform: "translate(-70.418 -82.678)",
    fill: "#17565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12767",
    "data-name": "Trazado 12767",
    d: "M94.457,128.13a.188.188,0,0,0,.188.188H99.61a.188.188,0,0,0,.188-.188.149.149,0,0,0,0-.02,2.677,2.677,0,0,0-5.339,0,.148.148,0,0,0,0,.02",
    transform: "translate(-72.382 -96.279)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12768",
    "data-name": "Trazado 12768",
    d: "M101.062,115.336a1.126,1.126,0,1,0,1.121-1.132,1.126,1.126,0,0,0-1.121,1.132",
    transform: "translate(-77.444 -87.514)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12769",
    "data-name": "Trazado 12769",
    d: "M92.471,156.767h5.375a.578.578,0,0,0,.578-.578v-7.144a.578.578,0,0,0-.578-.578H92.471a.578.578,0,0,0-.578.577v7.144a.578.578,0,0,0,.578.578",
    transform: "translate(-70.418 -113.77)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12770",
    "data-name": "Trazado 12770",
    d: "M94.457,168.7a.188.188,0,0,0,.188.188H99.61a.188.188,0,0,0,.188-.188.149.149,0,0,0,0-.02,2.677,2.677,0,0,0-5.339,0,.148.148,0,0,0,0,.02",
    transform: "translate(-72.382 -127.37)",
    fill: "#17565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12771",
    "data-name": "Trazado 12771",
    d: "M101.062,155.909a1.126,1.126,0,1,0,1.121-1.132,1.126,1.126,0,0,0-1.121,1.132",
    transform: "translate(-77.444 -118.605)",
    fill: "#17565c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12772",
    "data-name": "Trazado 12772",
    d: "M30.035,69.839H42.128a.351.351,0,0,0,.351-.351v-.035a.35.35,0,0,0-.351-.351H30.035a.351.351,0,0,0-.351.351v.035a.351.351,0,0,0,.351.351",
    transform: "translate(-22.747 -52.954)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12773",
    "data-name": "Trazado 12773",
    d: "M30.035,77.612H42.128a.351.351,0,0,0,.351-.351v-.035a.35.35,0,0,0-.351-.351H30.035a.351.351,0,0,0-.351.351v.035a.351.351,0,0,0,.351.351",
    transform: "translate(-22.747 -58.91)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12774",
    "data-name": "Trazado 12774",
    d: "M57.3,85.385h5.9a.248.248,0,0,0,.248-.248V84.9a.248.248,0,0,0-.248-.248H57.3a.248.248,0,0,0-.248.248v.24a.248.248,0,0,0,.248.248",
    transform: "translate(-43.723 -64.866)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12775",
    "data-name": "Trazado 12775",
    d: "M30.035,110.413H42.128a.351.351,0,0,0,.351-.351v-.035a.35.35,0,0,0-.351-.351H30.035a.351.351,0,0,0-.351.351v.035a.351.351,0,0,0,.351.351",
    transform: "translate(-22.747 -84.045)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12776",
    "data-name": "Trazado 12776",
    d: "M30.035,118.186H42.128a.351.351,0,0,0,.351-.351V117.8a.35.35,0,0,0-.351-.351H30.035a.351.351,0,0,0-.351.351v.035a.351.351,0,0,0,.351.351",
    transform: "translate(-22.747 -90.002)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12777",
    "data-name": "Trazado 12777",
    d: "M57.3,125.958h5.9a.248.248,0,0,0,.248-.248v-.24a.248.248,0,0,0-.248-.248H57.3a.248.248,0,0,0-.248.248v.24a.248.248,0,0,0,.248.248",
    transform: "translate(-43.723 -95.958)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12778",
    "data-name": "Trazado 12778",
    d: "M30.035,149.2H42.128a.351.351,0,0,0,.351-.351v-.035a.351.351,0,0,0-.351-.351H30.035a.351.351,0,0,0-.351.351v.035a.351.351,0,0,0,.351.351",
    transform: "translate(-22.747 -113.769)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12779",
    "data-name": "Trazado 12779",
    d: "M30.035,156.976H42.128a.351.351,0,0,0,.351-.351v-.035a.35.35,0,0,0-.351-.351H30.035a.351.351,0,0,0-.351.351v.035a.351.351,0,0,0,.351.351",
    transform: "translate(-22.747 -119.727)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12780",
    "data-name": "Trazado 12780",
    d: "M57.3,164.749h5.9a.248.248,0,0,0,.248-.248v-.24a.248.248,0,0,0-.248-.248H57.3a.248.248,0,0,0-.248.248v.24a.248.248,0,0,0,.248.248",
    transform: "translate(-43.723 -125.683)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12781",
    "data-name": "Trazado 12781",
    d: "M41.523,47.5H54.178a1.168,1.168,0,0,0,1.169-1.169v-.7H40.355v.7A1.169,1.169,0,0,0,41.523,47.5",
    transform: "translate(-30.924 -34.968)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12782",
    "data-name": "Trazado 12782",
    d: "M190.5,92.194l-1.637-4.118a2.019,2.019,0,0,1,1.376-2.721,2.409,2.409,0,0,1,3.04,1.366l1.329,4.464Z",
    transform: "translate(-144.599 -65.311)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12783",
    "data-name": "Trazado 12783",
    d: "M130.9,76.053l3.093-3.166a2.023,2.023,0,0,1,3.041.13,2.381,2.381,0,0,1-.012,3.308l-3.533,3.029Z",
    transform: "translate(-100.31 -55.372)",
    fill: "#b7006d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12784",
    "data-name": "Trazado 12784",
    d: "M164.032,81.761c1.84.067,3.4-2.952,3.552-7.171l-.493-.223c-.138,3.819-1.522,6.971-3.043,6.916s-2.786-4.6-2.649-8.373l-.575-.044c-.151,4.17,1.366,8.828,3.207,8.895",
    transform: "translate(-123.232 -55.837)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22364",
    "data-name": "Rect\\xE1ngulo 22364",
    width: 4.301,
    height: 3.638,
    transform: "translate(38.826 30.157) rotate(-87.928)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12785",
    "data-name": "Trazado 12785",
    d: "M172.049,116.995a.965.965,0,1,1-.929-1,.965.965,0,0,1,.929,1",
    transform: "translate(-130.362 -88.887)",
    fill: "#cccbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22365",
    "data-name": "Rect\\xE1ngulo 22365",
    width: 0.982,
    height: 0.982,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 36.205, 22.596)",
    fill: "#f1f1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12786",
    "data-name": "Trazado 12786",
    d: "M84.529,98.028a6.787,6.787,0,1,1-6.787,6.787A6.794,6.794,0,0,1,84.529,98.028Zm0,12.573a5.787,5.787,0,1,0-5.787-5.787A5.793,5.793,0,0,0,84.529,110.6Z",
    transform: "translate(-59.957 -75.502)",
    fill: "#a81674"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12787",
    "data-name": "Trazado 12787",
    d: "M84.529,95.7a6.787,6.787,0,1,1-6.787,6.787A6.794,6.794,0,0,1,84.529,95.7Zm0,12.573a5.787,5.787,0,1,0-5.787-5.787A5.793,5.793,0,0,0,84.529,108.277Z",
    transform: "translate(-59.957 -73.721)",
    fill: "#db2491"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12788",
    "data-name": "Trazado 12788",
    d: "M39.91,141.989l.07.121a.467.467,0,0,0,.638.171l9.192-5.307-.537-.93-9.192,5.307a.468.468,0,0,0-.171.638",
    transform: "translate(-30.535 -104.25)",
    fill: "#a81674"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12789",
    "data-name": "Trazado 12789",
    d: "M39.91,139.989l.07.121a.467.467,0,0,0,.638.171l9.192-5.307-.537-.93-9.192,5.307a.468.468,0,0,0-.171.638",
    transform: "translate(-30.535 -102.718)",
    fill: "#db2491"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoSupervisores);
export default __webpack_public_path__ + "static/media/icono_supervisores.becd3af14dc34b854a178cf317571812.svg";
export { ForwardRef as ReactComponent };